import { Link } from "react-router-dom";
import "./index.css";
import rating_icon from "../../img/reitingColor.svg";
import application from "../../img/application.svg";
import profile_icon from "../../img/profile-icon.svg";
import link_icon from "./link.svg";
import logo from "./mainLogo.png";

export function Rating() {
  const link_url = "https://t.me/+rQobcf8fkOA1MGJi";
  return (
    <section className="section mainPage flex flex-column sectionUser">
      <div className="sectionUserRating-content">
        <div className="headerUser flex flex-column">
          <div className="headerUser-avatar">
            <div className="headerUser-avatar-logo">
              <img src={logo} alt="" />
            </div>
            <div>
              <p className="semiBoldFontHeaderProfile">Мудрая жена чат</p>
              <p className="normalMediumBoldFontHeader">@WiseWife_chat</p>
            </div>
          </div>
          <a href={link_url} target="_blank" rel="noopener noreferrer">
            <img src={link_icon} alt="Link icon" />
          </a>
          {/* <img src={link_icon} alt=""/> */}
        </div>
        {/* <p className="semiBoldFontHeaderProfile user-text">Пользователи</p>
        <div className="conteinerUser  conteinerUser-block">
          <PositionRating />
        </div> */}
      </div>

      <div className="profile_footer">
        <Link to="/rating">
          <div className="footer_tab">
            <img src={rating_icon} alt="" />
            <span className="textMenu">Комьюнити</span>
          </div>
        </Link>
        <Link to="/">
          <div className="footer_tab">
            <img src={application} alt=""/>
            <span className="textMenu">Главная</span>
          </div>
        </Link>
        <Link to="/profile">
          <div className="footer_tab">
            <img src={profile_icon} alt=""/>
            <span className="textMenu">Профиль</span>
          </div>
        </Link>
      </div>
    </section>
  );
}
